import { __extends } from "tslib";
import { namespacedClassnames } from '../../common/namespace-classes';
import { Icon } from '../icon/icon';
import * as React from 'react';
// tslint:disable-next-line:max-line-length
var messageBoxIcon = "<svg width=\"17\" height=\"18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 9c0 4.6944-3.8056 8.5-8.5 8.5S0 13.6944 0 9 3.8056.5 8.5.5 17 4.3056 17 9zm-7 4.5c0 .5523-.4477 1-1 1H8c-.5523 0-1-.4477-1-1V9c0-.8284.6716-1.5 1.5-1.5S10 8.1716 10 9v4.5zM10 5c0 .8284-.6716 1.5-1.5 1.5S7 5.8284 7 5s.6716-1.5 1.5-1.5S10 4.1716 10 5z\" fill=\"#fff\"/></svg>";
var BaseMessageBox = /** @class */ (function (_super) {
    __extends(BaseMessageBox, _super);
    function BaseMessageBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseMessageBox.prototype.render = function () {
        var props = this.props;
        var isEmbedded = props.embedded ? 'is-embedded' : '';
        var classNames = namespacedClassnames('message-box', props.className, isEmbedded, props.type);
        var icon = props.icon ? typeof props.icon === 'string'
            ? React.createElement(Icon, { icon: props.icon }) : props.icon : React.createElement(Icon, { icon: messageBoxIcon });
        return (React.createElement("div", { className: classNames, style: { backgroundColor: props.bgColor } },
            icon,
            React.createElement("div", { className: 'content' }, props.children)));
    };
    return BaseMessageBox;
}(React.PureComponent));
export var CustomMessageBox = function (props) {
    return (React.createElement(BaseMessageBox, { type: 'custom', embedded: props.embedded, bgColor: props.bgColor, icon: props.icon, className: props.className }, props.children));
};
export var WarningMessageBox = function (props) {
    return (React.createElement(BaseMessageBox, { type: 'warning', embedded: props.embedded, className: props.className, icon: props.icon }, props.children));
};
export var AttentionMessageBox = function (props) {
    return (React.createElement(BaseMessageBox, { type: 'attention', embedded: props.embedded, className: props.className, icon: props.icon }, props.children));
};
export var InfoMessageBox = function (props) {
    return (React.createElement(BaseMessageBox, { type: 'info', embedded: props.embedded, className: props.className, icon: props.icon }, props.children));
};
export var NeutralMessageBox = function (props) {
    return (React.createElement(BaseMessageBox, { type: 'neutral', embedded: props.embedded, className: props.className, icon: props.icon }, props.children));
};
export var NeutralWhiteMessageBox = function (props) {
    return (React.createElement(BaseMessageBox, { type: 'neutral-white', embedded: props.embedded, className: props.className, icon: props.icon }, props.children));
};
//# sourceMappingURL=message-box.js.map